import { NgModule } from '@angular/core';

import { ConfiguratorAppRoutingModule } from './configurator-app-routing.module';

import { CommonModule } from '@angular/common';
import { ConfiguratorAppComponent } from './configurator-app.component';
import { ConfConfiguratorLayoutComponent } from './conf-layout/conf-configurator-layout/conf-configurator-layout.component';
import { ConfIntroductoryLayoutComponent } from './conf-layout/conf-introductory-layout/conf-introductory-layout.component';
import { ConfPredictiveLayoutComponent } from './conf-layout/conf-predictive-layout/conf-predictive-layout.component';
import { ConfSharedModule } from './Conf-Shared/conf-shared.module';//'src/app/configurator-app/Conf-Shared/conf-shared.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import {ConfError404Component} from './conf-layout/conf-error404/conf-error404.component';
import { RootService } from '../shared/services/root.service';
@NgModule({
  declarations: [
    ConfiguratorAppComponent,
    ConfConfiguratorLayoutComponent,
    ConfIntroductoryLayoutComponent,
    ConfError404Component,
    ConfPredictiveLayoutComponent
  ],
  imports: [
    CommonModule,
    ConfiguratorAppRoutingModule,
    ConfSharedModule,
    NgxSkeletonLoaderModule
  ],
  providers: [RootService],
  bootstrap: [ConfiguratorAppComponent]
})
export class ConfiguratorAppModule { }
